
import { NavbarComponent } from './layouts';
import {Route} from '@angular/router';

export const navbarRoute: Route = {
    path: '',
    component: NavbarComponent,
    outlet: 'navbar'
  };



// WEBPACK FOOTER //
// ./src/main/webapp/app/app.route.ts